type Props = { fill?: string };

const MoreIcon = ({ fill }: Props) => {
  return (
    <svg
      width="4"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M5.24537e-07 2C4.76254e-07 3.10457 0.895431 4 2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 4.82823e-08 2 0C0.895431 -4.82823e-08 5.72819e-07 0.89543 5.24537e-07 2ZM2.62267e-07 8C2.13985e-07 9.10457 0.895431 10 2 10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6C0.895431 6 3.1055e-07 6.89543 2.62267e-07 8ZM2 16C0.89543 16 -4.82823e-08 15.1046 0 14C4.82823e-08 12.8954 0.895431 12 2 12C3.10457 12 4 12.8954 4 14C4 15.1046 3.10457 16 2 16Z"
        fill={fill}
      />
    </svg>
  );
};

export default MoreIcon;
